import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

const usePhotoProvider = ({ locationState, user, navigate }) => {
  const [provider, setProvider] = useState(null);
  const [checkingProvider, setCheckingProvider] = useState(true);

  useEffect(() => {
    if (!user) {
      setProvider(null);
      setCheckingProvider(false);
      return;
    }

    if (locationState?.provider) {
      setProvider(locationState.provider);
      setCheckingProvider(false);
      return;
    }

    const connectedAccounts = Array.isArray(user.connectedAccounts)
      ? [...user.connectedAccounts]
      : [];

    if (connectedAccounts.length > 0) {
      connectedAccounts.sort(
        (a, b) => new Date(b.lastUsed || 0) - new Date(a.lastUsed || 0)
      );
      setProvider(connectedAccounts[0].provider);
      setCheckingProvider(false);
      return;
    }

    if (connectedAccounts.length === 0) {
      toast.error('Please connect a photo platform first');
      navigate('/');
    }

    setCheckingProvider(false);
  }, [locationState, navigate, user]);

  return { provider, checkingProvider };
};

export default usePhotoProvider;
